module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-kaoawase-planning-b53cae12cdda5379209adf28aebd4d7c.png";